import { render } from "./slider.vue?vue&type=template&id=0230e945&lang=pug"
import script from "./slider.vue?vue&type=script&lang=js"
export * from "./slider.vue?vue&type=script&lang=js"

import "./slider.vue?vue&type=style&index=0&id=0230e945&lang=less"

import exportComponent from "/home/runner/work/argos-control-web/argos-control-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSlider from 'quasar/src/components/slider/QSlider.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSlider});
